import React from "react";
import { Buttton } from "../components";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
    const navigate = useNavigate();
    return (
        <div className="page-not-found">
            <h1>Page Not Found</h1>
            <p>The page you are looking for does not exist.</p>
            <Buttton.Buttton
                children="Go to Home page"
                className="btn-solid-Aqua_Teal"
                onClick={() => navigate("/")}
            />
        </div>
    );
};

export default PageNotFound;
